import { call } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { getAuth } from 'actions/auth/login';
import { getLocale } from 'actions/language/selectors';
import { sendMessage } from 'api/messages';

export const getSMS = (state) => state.compose.sms;
export const getEmail = (state) => state.compose.email;
export const getPushNotification = (state) => state.compose.pushNotification;
export const getSubject = (state) => state.compose.subject;
export const getBody = (state) => state.compose.body;
export const getUserSearch = (state) => state.compose.userSearch;
export const getUsers = (state) => state.compose.users;
export const getSelectedUser = (state) => state.compose.selectedUser;
export const getUserSearchLoading = (state) => state.compose.usersLoading;

export const getSearchResults = createSelector([getUsers], (users) =>
  users.map(
    ({
      id,
      first_name,
      last_name,
      email,
      phone,
      company: { name: client }
    }) => ({
      id,
      name: `${first_name} ${last_name}`,
      client,
      email,
      phone
    })
  )
);

export const getDeliveryMethods = createSelector(
  [getSMS, getEmail, getPushNotification],
  (sms, email, push) => {
    const methods = [
      sms && 'sms',
      email && 'email',
      push && 'pushnotification'
    ].filter((i) => i);
    if (!methods.length) throw Error('Please select a message type.');
    return methods;
  }
);

export const getUserId = createSelector([getSelectedUser], ({ id }) => {
  if (id) return id;
  else throw Error('Please select a recipient for your message.');
});

export const getMessageData = createSelector(
  [getSubject, getBody],
  (subject, body) => {
    if (!body) throw Error('Please add some text to the body of your message.');
    return {
      subject,
      body
    };
  }
);

const generateMessages = (req, { subject, body }) => {
  switch (req) {
    case 'email':
      return {
        subject,
        body
      };
    case 'pushnotification':
      return {
        title: subject,
        body
      };
    case 'sms':
      return {
        body
      };
    default:
      throw Error('Delivery method not supported');
  }
};

export const getMessageRequests = createSelector(
  [getLocale, getAuth, getUserId, getDeliveryMethods, getMessageData],
  (locale, auth, userId, deliveryMethods, messageData) =>
    deliveryMethods.map((req) =>
      call(
        sendMessage,
        locale,
        auth,
        userId,
        req,
        generateMessages(req, messageData)
      )
    )
);



// WEBPACK FOOTER //
// ./src/actions/communication/compose/composeSelectors.js